import { Component, Input } from '@angular/core';
import { IItemsTableOptions } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/data-source/data-source-items/interfaces/items-table-options.interface';
import { IFilters } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filters.interface';
import { FiltersChannel } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/filters/models/filters-channel.model';
import { TableComponent } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tables/components/table/table.component';
import { ITablePagination } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table/table-pagination.interface';
import { ITableDataSource } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table-data-source.interface';
import { ITableSort } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table/table-sort.interface';
import { SessionService } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/services/session.service';
import { Sort } from '@angular/material/sort';
import { ICprUser } from '../../../users/interface/user.interface';
import { UsersService } from '../../../users/service/users.service';
import { ISample } from '../../interface/sample.interface';
import { SamplesService } from '../../service/samples.service';

@Component({
  selector: 'app-samples-table',
  templateUrl: './samples-table.component.html',
  styleUrls: ['./samples-table.component.scss'],
})
export class SamplesTableComponent extends TableComponent<ISample, string> {
  readonly headings = [
    'towId',
    'sampleNo',
    'sampleLatitude',
    'sampleLongitude',
    'chlorophyllIndex',
    'userId',
    'status',
    'comment',
    'updatedAt',
    'actions',
  ];
  readonly widths = [10, 10, 10, 10, 10, 10, 10, 12, 14, 14];

  @Input() mode: 'simple' | 'full' = 'full';

  @Input() filtersChannel?: FiltersChannel;
  @Input() options: IItemsTableOptions;
  @Input() dontCache = false;
  @Input() tableAlias: string;

  pageSize = this.options?.defaultPageSize || 15;
  canSort = false;

  defaultSort = 'SKIP';

  count: number;

  user: ICprUser;

  constructor(
    sessionService: SessionService,
    private readonly samples: SamplesService,
    private readonly users: UsersService,
  ) {
    super(sessionService);
  }

  async ngOnInit() {
    this.user = await this.users.getMe();
    super.ngOnInit();
  }

  protected getPaginated(
    filters: IFilters,
    sort: ITableSort,
    pagination: ITablePagination,
    search: string,
  ): Promise<ITableDataSource<ISample>> {
    return this.samples.getPaginated('', {
      filters,
      sort,
      pagination,
      search,
    });
  }

  protected override transformSort(sort: Sort): Sort {
    if (!sort?.active || !sort?.direction) {
      return this.defaultSort === 'SKIP' ? null : sort;
    }

    if (this.sortPrefix) {
      return {
        ...sort,
        active: `${this.sortPrefix}.${sort.active}`,
      };
    }

    return sort;
  }
}
